import React from "react";

import { FiTrash2 } from "react-icons/fi";
import Button from "@material-ui/core/Button";
import Popover from "@material-ui/core/Popover";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import ToggleButton from "@material-ui/lab/ToggleButton";
import Tooltip from "@material-ui/core/Tooltip";
import { DialogContent, Typography } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { Container } from "../style";

function BtnRemoveCategory({ onRemove, categoryName, ...props }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [disabled, setDisabled] = React.useState(true);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRemove = () => {
    handleClose();
    onRemove();
  };

  const open = Boolean(anchorEl);

  return (
    <React.Fragment>
        <Tooltip arrow placement="bottom" title="Excluir categoria">
          <ToggleButton {...props} onClick={handleClick}>
            <FiTrash2 style={{ fontSize: "20px" }} />
          </ToggleButton>
        </Tooltip>
        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <div>
            <DialogTitle>
              Tem certeza que deseja excluir o <strong>{categoryName}</strong>?{" "}
            </DialogTitle>
            <DialogContent>
              <Typography>
                Digite <span style={{ color: "red" }}>delete</span> para
                confirmar a exclusão
              </Typography>
              <TextField
                variant="outlined"
                size="small"
                onChange={(e) => {
                  if (e.target.value === "delete") {
                    setDisabled(false);
                  } else {
                    setDisabled(true);
                  }
                }}
              />
            </DialogContent>

            <DialogActions>
              <Button
                onClick={handleRemove}
                color="secondary"
                disabled={disabled}
                autoFocus
              >
                Sim
              </Button>
              <Button onClick={handleClose} color="default">
                Não
              </Button>
            </DialogActions>
          </div>
        </Popover>
    </React.Fragment>
  );
}

export default BtnRemoveCategory;
